import { ComponentType } from 'react'
import { CurrentUser } from './types'
import { DistributoriPhase } from './phases/Distributori'
import { GenerovaniPhase } from './phases/Generovani'
import { NastaveniPhase } from './phases/Nastaveni'
import { PlatbyPhase } from './phases/Platby'
import { JednotkyPhase } from './phases/Jednotky'
import { KontrolaPhase } from './phases/Kontrola'
import { FeePhase } from './phases/Fee'

export interface PhaseDef {
  key: string
  label: string
  /** Kdo fázi vidí. Imperium má jen generátor smluv, přidělování jednotek jen CEO. */
  visibleFor: (user: CurrentUser) => boolean
  component: ComponentType
}

export const PHASES: PhaseDef[] = [
  {
    key: 'generovani',
    label: 'Generování smluv',
    visibleFor: () => true,
    component: GenerovaniPhase,
  },
  {
    key: 'platby',
    label: 'Vklady / výběry',
    visibleFor: (u) => u.territory === 'APEX',
    component: PlatbyPhase,
  },
  {
    key: 'jednotky',
    label: 'Přidělení jednotek',
    visibleFor: (u) => u.territory === 'APEX' && u.isCeo,
    component: JednotkyPhase,
  },
  {
    key: 'kontrola',
    label: 'Kontrola přidělení',
    visibleFor: (u) => u.territory === 'APEX',
    component: KontrolaPhase,
  },
  {
    key: 'fee',
    label: 'Fee',
    visibleFor: (u) => u.territory === 'APEX',
    component: FeePhase,
  },
  {
    key: 'distributori',
    label: 'Distributoři',
    visibleFor: (u) => u.territory === 'APEX',
    component: DistributoriPhase,
  },
  {
    key: 'nastaveni',
    label: 'Nastavení',
    visibleFor: (u) => u.territory === 'APEX' && u.isCeo,
    component: NastaveniPhase,
  },
]

export function visiblePhases(user: CurrentUser): PhaseDef[] {
  return PHASES.filter((p) => p.visibleFor(user))
}
